import { jsx } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import SearchIcon from "@mui/icons-material/Search";
import { InputField } from "../input-field/InputField.js";
function SearchInputField({
  fullWidth = true,
  ...rest
}) {
  const { gray } = useColors();
  return /* @__PURE__ */ jsx(
    InputField,
    {
      ...rest,
      fullWidth,
      startIcon: /* @__PURE__ */ jsx(SearchIcon, { sx: { fontSize: 20, color: gray[500] } })
    }
  );
}
export {
  SearchInputField
};
